import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Customize_Css/Pagination.css';
import {Dropdown,Modal,Button} from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaPlus, FaUpload, FaTrashAlt, FaFileExport, FaEdit, FaSearch, FaEye, FaStore, FaBoxOpen } from 'react-icons/fa';
import axios from 'axios';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';
import '../Customize_Css/ViewVendor.css';
const formatDate = (dateString) => {
    const options = { day: '2-digit', month: 'long', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options).replace(/ /g, '-');
};

const ViewVendor = () => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const epicxTenantId = localStorage.getItem('epicxTenantId');
    const authorizationToken = localStorage.getItem('token');
    const navigate = useNavigate();
    const location = useLocation();
    const openedVendorRef = useRef(false);
    const [data, setData] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [selectedItems, setSelectedItems] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [deletePrompt, setDeletePrompt] = useState(null);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [originalData, setOriginalData] = useState([]);

    useEffect(() => {
    if (!epicxTenantId || !authorizationToken) {
        return;
    }

    const fetchVendors = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/vendor/api/vendor/${epicxTenantId}`, {
                headers: {
                    Authorization: `Bearer ${authorizationToken}`,
                },
            });

            const vendors = Array.isArray(response.data?.vendors) ? response.data.vendors : [];
            setOriginalData(vendors);
            setData(vendors);
        } catch (error) {
            console.error('Error fetching vendors:', error);
            if (error.response?.status === 404) {
                setOriginalData([]);
                setData([]);
                return;
            }
            toast.error('Failed to load vendors');
        }
    };

    fetchVendors();
}, [epicxTenantId, authorizationToken, BASE_URL]);

    useEffect(() => {
        const openVendorId = location.state?.openVendorId;
        if (!openVendorId || openedVendorRef.current || data.length === 0) return;
        const vendor = data.find((item) => String(item._id) === String(openVendorId));
        if (vendor) {
            openedVendorRef.current = true;
            setSelectedVendor(vendor);
            setShowModal(true);
        }
    }, [data, location.state]);

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
        setData((prevData) => {
            const sortedData = [...prevData].sort((a, b) => {
                if (a[key] < b[key]) {
                    return direction === 'asc' ? -1 : 1;
                }
                if (a[key] > b[key]) {
                    return direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
            return sortedData;
        });
    };

    const handleSearch = (value) => {
        setSearchTerm(value.toLowerCase());
    
        if (value.trim() === '') {
            setData(originalData);  
        } else {
            const filteredData = originalData.filter((item) =>
                Object.keys(item).some((key) =>
                    item[key].toString().toLowerCase().includes(value.toLowerCase())
                )
            );
            setData(filteredData);
        }
        setCurrentPage(1); 
    };
    
    const handleSelectAll = () => {
        if (selectedItems.length === data.length) {
            setSelectedItems([]);
        } else {
            setSelectedItems(data.map(item => item._id));
        }
    };

    const handleSelectItem = (_id) => {
        if (selectedItems.includes(_id)) {
            setSelectedItems(selectedItems.filter(item => item !== _id));
        } else {
            setSelectedItems([...selectedItems, _id]);
        }
    };

    const handleDelete = () => {
        if (selectedItems.length === 0) {
            toast.error('No items selected for deletion');
            return;
        }
        const vendors = data.filter((item) => selectedItems.includes(item._id));
        setDeletePrompt(vendors);
    };

    const confirmDelete = async () => {
        const vendors = deletePrompt || [];
        if (vendors.length === 0) return;
        try {
            await Promise.all(vendors.map((vendor) =>
                axios.put(`${BASE_URL}/vendor/api/vendor/${epicxTenantId}/delete/${vendor._id}`,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${authorizationToken}`,
                        },
                    }
                )
            ));
            const response = await axios.get(`${BASE_URL}/vendor/api/vendor/${epicxTenantId}`,
                {
                    headers: {
                        Authorization: `Bearer ${authorizationToken}`,
                    },
                }
            );
            const vendorsLeft = response.data.vendors || [];
            setData(vendorsLeft);
            setOriginalData(vendorsLeft);
            setSelectedItems([]);
            setDeletePrompt(null);
            toast.success(vendors.length === 1
                ? `${vendors[0].vendorName} and their products were deleted`
                : `${vendors.length} vendors and their products were deleted`);
        } catch (error) {
            console.error('Error deleting vendors:', error);
            toast.error('Error deleting items');
        }
    };
    const handleEdit = () => {
        if (selectedItems.length === 1) {
            const [selectedId] = selectedItems; 
            navigate(`/updatevendor/${selectedId}`); 
        } else {
            toast.error("Please select exactly one product vendor to edit");
        }
    };
    const handleViewDetails = async (vendorId) => {
        const vendor = data.find((item) => item._id === vendorId);
        if (vendor) {
            setSelectedVendor(vendor);
            setShowModal(true);
        }
        try {
            const response = await axios.get(`${BASE_URL}/vendor/api/vendor/${epicxTenantId}/${vendorId}`, {
                headers: {
                    Authorization: `Bearer ${authorizationToken}`,
                },
            });
            if (response.data?.vendor) {
                setSelectedVendor(response.data.vendor);
            }
        } catch (error) {
            console.error('Error fetching vendor details:', error);
        }
    };
    const handleExport = () => {
        const dataToExport = selectedItems.length > 0 
            ? data.filter(item => selectedItems.includes(item._id)) 
            : data;
    
        const exportData = dataToExport.map(item => {
            const timeAvailabilitySlots = item.timeAvailabilitySlots.join(', ');
            const daySlots = item.daySlots.join(', ');
    
            const categories = item.categories.map(category => category.categoryName).join(', ');
            const productsByCategory = Object.entries(item.productsByCategory).map(([categoryId, products]) => {
                return products.map(product => product.productName).join(', ');
            }).join('; ');

            const documents = item.documents.map(doc => 
                `${doc.documentName} (No: ${doc.documentNumber}, Type: ${doc.documentType}, Expiry: ${new Date(doc.documentExpiryDate).toLocaleDateString()})`
            ).join('; ');
            return {
                vendorName: item.vendorName,
                GSTNumber: item.GSTNumber,
                phoneNumber: item.phoneNumber,
                emailAddress: item.emailAddress,
                country: item.country,
                state: item.state,
                city: item.city,
                useMyLocation: item.useMyLocation,
                currentLocation: item.currentLocation,
                address: item.address,
                consumable: item.consumable,
                timeAvailabilitySlots: timeAvailabilitySlots,  
                daySlots: daySlots, 
                documents: documents,  
                categories: categories,  
                productsByCategory: productsByCategory, 
                createdAt: new Date(item.createdAt).toLocaleDateString(),
                updatedAt: new Date(item.updatedAt).toLocaleDateString()
            };
        });
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "ProductVendors");
        XLSX.writeFile(wb, 'ProductVendors_data.xlsx');
    };
    
    // Pagination 
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = Array.isArray(data) ? data.slice(indexOfFirstItem, indexOfLastItem) : [];
    const totalPages = Math.ceil(data.length / itemsPerPage);
    const vendorColumns = [
        { key: 'vendorName', label: 'Vendor Name' },
        { key: 'city', label: 'City' },
        { key: 'phoneNumber', label: 'Phone Number' },
        { key: 'emailAddress', label: 'Email Address' },
        { key: 'address', label: 'Address' },
        { key: 'GSTNumber', label: 'GST Number' },
        { key: 'Time Slots', label: 'Time Slots' },
        { key: 'Day Slots', label: 'Day Slots' },
    ];

    return (
        <>
            <Sidebar />
            <div className="vendors-page">
                <header className="vendors-hero">
                    <div>
                        <p className="vendors-kicker">Vendors</p>
                        <h1>Product Vendors List</h1>
                        <p>Browse, find, and manage product vendors for your store.</p>
                    </div>
                    <button
                        className="vendors-primary-btn"
                        onClick={() => navigate(`/addvendor/${epicxTenantId}`)}
                    >
                        <FaPlus /> Add vendor
                    </button>
                </header>

                <section className="vendors-toolbar" aria-label="Vendor search and actions">
                    <div className="vendors-search">
                        <FaSearch aria-hidden="true" />
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search vendors..."
                            aria-label="Search vendors"
                            value={searchTerm}
                            onChange={(e) => handleSearch(e.target.value)}
                        />
                    </div>
                    <Dropdown>
                        <Dropdown.Toggle className="vendors-action-btn">
                            Actions
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item>
                                <FaUpload className="me-2" /> Push to all
                            </Dropdown.Item>
                            <Dropdown.Item onClick={handleDelete} disabled={selectedItems.length === 0}>
                                <FaTrashAlt className="me-2" /> Delete
                            </Dropdown.Item>

                            <Dropdown.Item onClick={handleExport}>
                                <FaFileExport className="me-2" /> Export
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </section>

                <div className="vendors-card">
                    <div className="vendors-card-head">
                        <div>
                            <h2>All Product Vendors</h2>
                            <p>Select a vendor to edit, delete, or view full details.</p>
                        </div>
                        <span className="vendors-count">
                            <FaStore aria-hidden="true" />
                            {data.length} {data.length === 1 ? 'vendor' : 'vendors'}
                        </span>
                    </div>
                    <div className="vendors-card-body">
                        <div className="vendors-table-wrap">
                            <table className="vendors-table">
                                <thead>
                                    <tr>
                                        <th className="vendors-check-cell">
                                            <input
                                                className="vendors-checkbox"
                                                type="checkbox"
                                                aria-label="Select all vendors"
                                                checked={data.length > 0 && selectedItems.length === data.length}
                                                onChange={handleSelectAll}
                                            />
                                        </th>
                                        {vendorColumns.map((column) => (
                                            <th
                                                key={column.key}
                                                className={column.key === 'vendorName' ? 'vendors-sticky-name' : undefined}
                                                onClick={() => handleSort(column.key)}
                                            >
                                                {column.label}
                                                {sortConfig.key === column.key ? (sortConfig.direction === 'asc' ? ' ▲' : ' ▼') : ''}
                                            </th>
                                        ))}
                                        <th className="vendors-action-cell">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.length > 0 ? currentData.map((item) => (
                                        <tr key={item._id} className={selectedItems.includes(item._id) ? 'is-selected' : ''}>
                                            <td className="vendors-check-cell">
                                                <input
                                                    className="vendors-checkbox"
                                                    type="checkbox"
                                                    aria-label={`Select ${item.vendorName}`}
                                                    checked={selectedItems.includes(item._id)}
                                                    onChange={() => handleSelectItem(item._id)}
                                                />
                                            </td>
                                            <td className="vendors-sticky-name"><span className="vendor-name">{item.vendorName}</span></td>
                                            <td>{item.city}</td>
                                            <td>{item.phoneNumber}</td>
                                            <td>{item.emailAddress}</td>
                                            <td className="vendors-address">{item.address}</td>
                                            <td><span className="vendor-gst">{item.GSTNumber}</span></td>
                                            <td>{item.timeAvailabilitySlots.join(', ')}</td>
                                            <td className="vendors-day-cell">
                                                <span className="vendors-lines-3" title={item.daySlots.join(', ')}>
                                                    {item.daySlots.join(', ')}
                                                </span>
                                            </td>
                                            <td className="vendors-action-cell">
                                                <div className="vendors-action-group">
                                                    <button
                                                        type="button"
                                                        className="vendors-icon-btn vendors-icon-btn--view"
                                                        aria-label={`View details for ${item.vendorName}`}
                                                        title="View details"
                                                        onClick={() => handleViewDetails(item._id)}
                                                    >
                                                        <FaEye aria-hidden="true" />
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="vendors-icon-btn vendors-icon-btn--edit"
                                                        aria-label={`Edit ${item.vendorName}`}
                                                        title="Edit vendor"
                                                        onClick={() => navigate(`/updatevendor/${item._id}`)}
                                                    >
                                                        <FaEdit aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan="10">
                                                <div className="vendors-empty">
                                                    <span><FaStore aria-hidden="true" /></span>
                                                    <h3>No vendors found</h3>
                                                    <p>Try another search or add a new product vendor.</p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="vendors-card-footer">
                        <span className="vendors-page-summary">
                            {data.length > 0
                                ? `Showing ${indexOfFirstItem + 1}–${Math.min(indexOfLastItem, data.length)} of ${data.length}`
                                : 'Showing 0 vendors'}
                        </span>
                        <div className="vendors-pagination">
                            <nav>
                                <ul className="pagination mb-0" aria-label="Vendors pagination">
                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link btn-sm" onClick={() => setCurrentPage(1)} aria-label="First page">&laquo;</button>
                                    </li>
                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link btn-sm" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} aria-label="Previous page">&lt;</button>
                                    </li>
                                    <li className="page-item active">
                                        <button className="page-link btn-sm" aria-current="page">{currentPage}</button>
                                    </li>
                                    <li className={`page-item ${currentPage === totalPages || totalPages === 0 ? 'disabled' : ''}`}>
                                        <button className="page-link btn-sm" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} aria-label="Next page">&gt;</button>
                                    </li>
                                    <li className={`page-item ${currentPage === totalPages || totalPages === 0 ? 'disabled' : ''}`}>
                                        <button className="page-link btn-sm" onClick={() => setCurrentPage(totalPages || 1)} aria-label="Last page">&raquo;</button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>

            <Modal
                show={Boolean(deletePrompt)}
                onHide={() => setDeletePrompt(null)}
                centered
                dialogClassName="vendor-confirm-dialog"
                contentClassName="vendor-confirm-modal"
            >
                <Modal.Body className="vendor-confirm-body">
                    <div className="vendor-confirm-icon" aria-hidden="true">
                        <FaTrashAlt />
                    </div>
                    <h3>{deletePrompt?.length === 1 ? 'Delete this vendor?' : `Delete ${deletePrompt?.length || 0} vendors?`}</h3>
                    <p>
                        <strong>{(deletePrompt || []).map((vendor) => vendor.vendorName).join(', ')}</strong> and all products added for {deletePrompt?.length === 1 ? 'this vendor' : 'these vendors'} will be removed.
                    </p>
                </Modal.Body>
                <Modal.Footer className="vendor-confirm-footer">
                    <Button className="vendor-confirm-cancel" onClick={() => setDeletePrompt(null)}>
                        Cancel
                    </Button>
                    <Button className="vendor-confirm-delete" onClick={confirmDelete}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" centered dialogClassName="vendor-details-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Product Vendor Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedVendor ? (
                        <div className="vendor-details-content">
                            <div className="vendor-details-title">
                                {selectedVendor.profileImage ? (
                                    <img className="vendor-details-photo" src={selectedVendor.profileImage} alt={selectedVendor.vendorName || 'Vendor profile'} />
                                ) : (
                                    <span><FaStore aria-hidden="true" /></span>
                                )}
                                <div>
                                    <small>Vendor</small>
                                    <h3>{selectedVendor.vendorName || 'N/A'}</h3>
                                    <p>{selectedVendor.shopName || 'Shop name not added'}</p>
                                </div>
                            </div>
                            <div className="vendor-details-grid">
                                <div><span>Phone Number</span><strong>{selectedVendor.phoneNumber || 'N/A'}</strong></div>
                                <div><span>Email Address</span><strong>{selectedVendor.emailAddress || 'N/A'}</strong></div>
                                <div><span>GST Number</span><strong>{selectedVendor.GSTNumber || 'N/A'}</strong></div>
                                <div><span>Country</span><strong>{selectedVendor.country || 'N/A'}</strong></div>
                                <div><span>State</span><strong>{selectedVendor.state || 'N/A'}</strong></div>
                                <div><span>City</span><strong>{selectedVendor.city || 'N/A'}</strong></div>
                                <div><span>Current Location</span><strong>{selectedVendor.currentLocation || 'N/A'}</strong></div>
                                <div>
                                    <span>Live Location</span>
                                    <strong>
                                        {selectedVendor.useMyLocation?.latitude && selectedVendor.useMyLocation?.longitude
                                            ? `${selectedVendor.useMyLocation.latitude}, ${selectedVendor.useMyLocation.longitude}`
                                            : 'N/A'}
                                    </strong>
                                </div>
                                <div className="details-wide"><span>Address</span><strong>{selectedVendor.address || 'N/A'}</strong></div>
                                <div><span>Consumable</span><strong>{selectedVendor.consumable || 'N/A'}</strong></div>
                                <div className="details-wide">
                                    <span>Categories</span>
                                    <strong>
                                        {selectedVendor.categories && selectedVendor.categories.length > 0
                                            ? selectedVendor.categories.map((category) => category.categoryName || 'Unnamed Category').join(', ')
                                            : 'N/A'}
                                    </strong>
                                </div>
                                <div className="details-wide">
                                    <span>Time Slots</span>
                                    <div className="vendor-detail-chips">
                                        {(selectedVendor.timeAvailabilitySlots || []).length > 0
                                            ? selectedVendor.timeAvailabilitySlots.map((slot) => <span key={slot}>{slot}</span>)
                                            : <strong>N/A</strong>}
                                    </div>
                                </div>
                                <div className="details-wide">
                                    <span>Day Slots</span>
                                    <div className="vendor-detail-chips">
                                        {(selectedVendor.daySlots || []).length > 0
                                            ? selectedVendor.daySlots.map((day) => <span key={day}>{day}</span>)
                                            : <strong>N/A</strong>}
                                    </div>
                                </div>
                            </div>

                            <section className="vendor-details-section">
                                <h4><FaBoxOpen aria-hidden="true" /> Products</h4>
                                {Object.entries(selectedVendor.productsByCategory || {}).map(([category, products]) => {
                                    const activeProducts = (products || []).filter((product) => product.statusValue === 1);
                                    if (activeProducts.length === 0) return null;
                                    return (
                                        <div key={category} className="vendor-product-group">
                                            <p>{category}</p>
                                            <ul>
                                                {activeProducts.map((product) => (
                                                    <li key={product.productId || product._id?.$oid || product._id}>
                                                        {product.productName}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    );
                                })}
                            </section>

                            <section className="vendor-details-section">
                                <h4>Documents</h4>
                                {selectedVendor.documents && selectedVendor.documents.length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="vendor-docs-table">
                                            <thead>
                                                <tr>
                                                    <th>Document Name</th>
                                                    <th>Document Number</th>
                                                    <th>Document Type</th>
                                                    <th>Expiry Date</th>
                                                    <th>File</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedVendor.documents.map((doc, index) => (
                                                    <tr key={index}>
                                                        <td>{doc.documentName || 'N/A'}</td>
                                                        <td>{doc.documentNumber || 'N/A'}</td>
                                                        <td>{doc.documentType || 'N/A'}</td>
                                                        <td>{formatDate(doc.documentExpiryDate) || 'N/A'}</td>
                                                        <td>
                                                            {doc.documentFile && (
                                                                <a
                                                                    href={doc.documentFile}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="vendors-view-btn"
                                                                >
                                                                    <FaEye aria-hidden="true" /> View
                                                                </a>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <p className="vendor-details-empty">No documents available.</p>
                                )}
                            </section>

                            <div className="vendor-details-grid">
                                <div><span>Created At</span><strong>{formatDate(selectedVendor.createdAt) || 'N/A'}</strong></div>
                                <div><span>Updated At</span><strong>{formatDate(selectedVendor.updatedAt) || 'N/A'}</strong></div>
                            </div>
                        </div>
                    ) : (
                        <p className="vendor-details-empty">No vendor details available.</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button className="vendors-modal-close" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <div className="vendors-footer">
                <Footer />
            </div>
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={true}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999 }} 
            />
            </div>
        </>
    );
};

export default ViewVendor;
